import type { Step } from '@/components/wizard/Step';

import type { IngestionPipelineWizardState } from './IngestionPipelineWizardState';
import { PartitioningStep } from './steps/PartitioningStep';
import { PipelineDetailsStep } from './steps/PipelineDetailsStep';
import { ReviewStep } from './steps/ReviewStep';
import { SourceStep } from './steps/SourceStep';

export const IngestionPipelineCreationFlow: Step<IngestionPipelineWizardState> =
  {
    id: 'pipeline_details',
    Component: PipelineDetailsStep,
    next: [
      {
        id: 'source',
        Component: SourceStep,
        next: [
          {
            id: 'partitioning',
            Component: PartitioningStep,
            next: [
              {
                id: 'review',
                Component: ReviewStep,
              },
            ],
          },
        ],
      },
    ],
  };
